import { createSelector } from 'reselect';

import type { IShareFieldRealtorsAndAgencies } from '../../types/redux/shareRealtorsAndAgencies';
import { getCurrentTabState } from '../tabs';

/**
 * Достаем из стора по id риелтора или агентство,
 * берем урл для картинки и его первую букву из имени/названия
 */
export function getPreviewImage(cianUserId: number) {
  return createSelector(getCurrentTabState, tabState => {
    const listingItems = (tabState as IShareFieldRealtorsAndAgencies).listing.items;
    const item = listingItems.find(item => item.cianUserId === cianUserId);
    const imgUrl = item?.avatarUrl || null;
    const firstLetter = item?.name.substr(0, 1).toUpperCase() || null;

    return {
      imgUrl,
      firstLetter,
    };
  });
}
